import { ViewFactory } from 'wdc-cube-react'

import { TheMapMarkDetailsScope } from '../tm_md_details_scopes'
import { TheMapMarkDetailsView } from './tm_md_details_view'

export function registerViews(rv = ViewFactory.register) {
    rv(TheMapMarkDetailsScope, TheMapMarkDetailsView)
}
